import React from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { Card } from '~/components/Card';
import { EditPhone, StaticPhone } from '~/components/Profile/LoginInfo/Phone';
import { AuthContext, AuthContextType, ServicesContext } from '~/services';
import { useServiceSubscribe } from '~/util';
import { MfaGoogleAuth } from './MfaGoogleAuth';

export function MfaEnrollment() {
    const services = React.useContext(ServicesContext);
    const { authenticated } = React.useContext(AuthContext) as AuthContextType;
    const history = useHistory();
    const mfaEnrollment = services.user.getMfaEnrollment();
    const [editingPhone, setEditingPhone] = React.useState(false);
    const [userPhone, setUserPhone] = React.useState<UserPhoneType>();
    const [googleAuthEnrolled, setGoogleAuthEnrolled] = React.useState(false);

    // load existing unverified user phones
    React.useEffect(() => {
        (async () => {
            if (mfaEnrollment?.user.id) {
                const result = await services.api.call({
                    method: 'get',
                    url: `/api/user-phones?user.id=${mfaEnrollment?.user.id}`,
                });
                setUserPhone(result.data['hydra:member']?.[0]);
            }
        })();
    }, [mfaEnrollment?.user.id, services.api]);

    function onPhoneUpdate(phone: UserPhoneType) {
        setUserPhone(phone);
    }

    function onPhoneDelete(phoneId: number) {
        if (phoneId === userPhone?.id) {
            setUserPhone(undefined);
        }
    }

    function onUserUpdate() {
        const updatedUser = services.user.get();
        setUserPhone(updatedUser?.user_phones?.[0]);
    }

    function redirectToLogin() {
        history.push('/');
    }

    useServiceSubscribe(services.user.events.userUpdated, onUserUpdate);
    useServiceSubscribe(services.user.events.userLoggedOut, redirectToLogin);

    function finishEnrollment() {
        services.user.doLogin(services.user.get());
        history.push('/dashboard');
    }

    return authenticated ? (
        <Redirect to="/dashboard" />
    ) : (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12 col-md-8 col-lg-6">
                    <Card title="Enable 2-Step Verification">
                        <p>2-Step Verification adds an extra layer of security to your account.</p>
                        {mfaEnrollment?.options.includes('google') && (
                            <>
                                <MfaGoogleAuth onMfaUpdate={setGoogleAuthEnrolled} />
                                <br />
                            </>
                        )}
                        {mfaEnrollment?.options.includes('sms') && !editingPhone ? (
                            <StaticPhone
                                edit={() => setEditingPhone((prev) => !prev)}
                                userPhone={userPhone}
                            />
                        ) : (
                            <EditPhone
                                edit={() => setEditingPhone((prev) => !prev)}
                                userPhone={userPhone}
                                onPhoneUpdate={onPhoneUpdate}
                                onPhoneDelete={onPhoneDelete}
                            />
                        )}
                        <hr className="my-3" />
                        <div className="text-end">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={finishEnrollment}
                                disabled={!userPhone?.two_factor_verified && !googleAuthEnrolled}
                            >
                                Continue
                            </button>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    );
}
